import { useEffect } from 'react'
import styled from 'styled-components'
import { GapManager } from '@/features/cms/components/CMS/components/GapManager'
import { type InferGetServerSidePropsType } from 'next'
import { type getServerSideProps } from '@/pages'
import { CMSPage } from '@/features/cms/components/CMS/CMSPage'
import { useIsGuestUser } from '@/features/account/services/User/hooks'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { routes } from '@shared/constants/routes'

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

export const UngatedHomePage = ({ cmsData }: Props) => {
  const isGuestUser = useIsGuestUser()
  const router = useSegwayRouter()

  useEffect(() => {
    if (isGuestUser) {
      router.replace(`${routes.GLOBAL_HOMEPAGE.url}${window.location.search}`)
    }
  }, [isGuestUser, router])

  return (
    <Container>
      <CMSPage cmsData={cmsData} />
    </Container>
  )
}

const Container = styled.div`
  /* GHP CMS content types use a custom max width. To use them on UHP we need to set it globally to match */
  && * {
    --content-max-width: 1280px;
  }

  /* remove negative margins and top/bottom margin */
  ${GapManager}, .with-background {
    margin: 0;
  }
`
